export const FETCH_PRIVATE_MESSAGE_REQUEST = "FETCH_PRIVATE_MESSAGE_REQUEST";
export const FETCH_PRIVATE_MESSAGE_SUCCESS = "FETCH_PRIVATE_MESSAGE_SUCCESS";
export const FETCH_PRIVATE_MESSAGE_ERROR = "FETCH_PRIVATE_MESSAGE_ERROR";

export const FETCH_USER_FRIENDS_REQUEST = "FETCH_USER_FRIENDS_REQUEST";
export const FETCH_USER_FRIENDS_SUCCESS = "FETCH_USER_FRIENDS_SUCCESS";
export const FETCH_USER_FRIENDS_ERROR = "FETCH_USER_FRIENDS_ERROR";

export const FETCH_STUDENTS_BY_MATRIC_REQUEST =
  "FETCH_STUDENTS_BY_MATRIC_REQUEST";
export const FETCH_STUDENTS_BY_MATRIC_SUCCESS =
  "FETCH_STUDENTS_BY_MATRIC_SUCCESS";
export const FETCH_STUDENTS_BY_MATRIC_ERROR = "FETCH_STUDENTS_BY_MATRIC_ERROR";

export const ADD_USER_FRIEND_REQUEST = "ADD_USER_FRIEND_REQUEST";
export const ADD_USER_FRIEND_SUCCESS = "ADD_USER_FRIEND_SUCCESS";
export const ADD_USER_FRIEND_ERROR = "ADD_USER_FRIEND_ERROR";

export const MESSAGE_COUNT_REQUEST = "MESSAGE_COUNT_REQUEST";
export const MESSAGE_COUNT_SUCCESS = "MESSAGE_COUNT_SUCCESS";
export const MESSAGE_COUNT_ERROR = "MESSAGE_COUNT_ERROR";

export const UPDATE_ACTIVE_TAB = "UPDATE_ACTIVE_TAB";

export const FETCH_MESSAGE_REQUEST = "FETCH_MESSAGE_REQUEST";
export const FETCH_MESSAGE_SUCCESS = "FETCH_MESSAGE_SUCCESS";
export const FETCH_MESSAGE_ERROR = "FETCH_MESSAGE_ERROR";
